module.exports = __webpack_public_path__ + "img/nec.8a18dea8.png";